import { resolveIslandPortalContainer } from './resolve-island-portal-container.js';

/**
 * @param {Element | null | undefined} islandRootElement
 * @returns {() => HTMLElement | undefined}
 */
export function createIslandPortalContainerCallback(islandRootElement) {
	return () => resolveIslandPortalContainer(islandRootElement);
}

/**
 * Flat DefaultPropsProvider values for MUI overlay components.
 * @param {() => HTMLElement | undefined} getPortalContainer
 */
export function createIslandPortalDefaultProps(getPortalContainer) {
	return {
		MuiModal: {
			container: getPortalContainer,
		},
		MuiPopover: {
			container: getPortalContainer,
		},
		MuiPopper: {
			container: getPortalContainer,
		},
	};
}
